/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Today_Empty_CtaInputs */

const en_us2_plan_build_today_empty_cta = /** @type {(inputs: Plan_Build_Today_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build my workouts`)
};

const pt_br2_plan_build_today_empty_cta = /** @type {(inputs: Plan_Build_Today_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar meu treino`)
};

const es_419_plan_build_today_empty_cta = /** @type {(inputs: Plan_Build_Today_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armar mis entrenamientos`)
};

const pt_pt2_plan_build_today_empty_cta = /** @type {(inputs: Plan_Build_Today_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar o meu treino`)
};

const fr_fr2_plan_build_today_empty_cta = /** @type {(inputs: Plan_Build_Today_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer mes séances`)
};

const de_de2_plan_build_today_empty_cta = /** @type {(inputs: Plan_Build_Today_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings bauen`)
};

const it_it2_plan_build_today_empty_cta = /** @type {(inputs: Plan_Build_Today_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea i miei allenamenti`)
};

/**
* | output |
* | --- |
* | "Build my workouts" |
*
* @param {Plan_Build_Today_Empty_CtaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_today_empty_cta = /** @type {((inputs?: Plan_Build_Today_Empty_CtaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Today_Empty_CtaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_today_empty_cta(inputs)
	if (locale === "es-419") return es_419_plan_build_today_empty_cta(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_today_empty_cta(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_today_empty_cta(inputs)
	if (locale === "de-DE") return de_de2_plan_build_today_empty_cta(inputs)
	if (locale === "it-IT") return it_it2_plan_build_today_empty_cta(inputs)
	return en_us2_plan_build_today_empty_cta(inputs)
});
export { plan_build_today_empty_cta as "plan-build.today_empty_cta" }